import tw from 'tailwind-styled-components'
import {AnyColor, colorTextClass} from '@components/common/base/design-system'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {cn} from '@containers/html-utils'

export const TwMenuContainer = tw.div<{$popupMenu?: boolean}>`
  max-h-628
  flex
  flex-col
  ${p =>
    cn(
      !p.$popupMenu &&
        cn(
          'border-1',
          'border-solid',
          'border-line-base',
          'rounded-8',
          'bg-background-primary'
        )
    )}
`

export const TwMenuScrollContainer = tw(WithPerfectScrollbar)<{
  $popupMenu?: boolean
}>`
  flex-1
  ${p => (p.$popupMenu ? 'pt-4 pb-12' : 'py-8')}
`

export const TwMenu = tw.div`
  flex
  flex-col
  min-w-0
`

export const TwMenuItem = tw.div<{
  $forceHover?: boolean
  $disabled?: boolean
  $popupMenu?: boolean
}>`
  group
  min-w-0
  px-12
  py-8
  h-32
  flex
  flex-row
  items-center
  gap-8
  select-none
  ${p => {
    const cx: string[] = []
    if (p.$disabled) {
      cx.push('cursor-default')
    } else {
      cx.push(
        'cursor-pointer',
        'hover:bg-background-hover',
        'active:bg-background-active'
      )
      if (p.$forceHover) {
        cx.push('bg-background-active')
      }
    }

    if (p.$popupMenu) {
      cx.push('mx-16', ' my-4', 'rounded-8')
    }

    return cx.join(' ')
  }}
`
TwMenuItem.displayName = 'TwMenuItem'

export const TwTitle = tw.div<{$disabled?: boolean; $color?: AnyColor}>`
  min-w-0
  flex-1
  text-14
  leading-4
  overflow-hidden
  text-ellipsis
  text-no-wrap
  ${p =>
    cn(
      p.$disabled && 'text-disabled-new',
      !p.$disabled && !p.$color && 'text-primary',
      !p.$disabled && p.$color && colorTextClass(p.$color)
    )}
`
TwTitle.displayName = 'TwTitle'

export const TwAfter = tw.div`
  min-w-0
  flex-none
  ml-auto
  overflow-hidden
  text-ellipsis
  text-no-wrap
`

export const TwMenuSeparator = tw.div`
  relative
  h-[17px]
  after:content-[""]
  after:block
  after:absolute
  after:top-[9px]
  after:left-0
  after:right-0
  after:h-[1px]
  after:bg-line-base
`

export const TwMenuSeparatorEmpty = tw.div`
  relative
  h-8
`

export const TwMenuCustomItem = tw.div`
`
